import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const QuoteSection = () => {
  const [content, setContent] = useState({
    quote: "The miracle is this: the more we share, the more we have.",
    author: "Leonard Nimoy"
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/homepage-content`);
        if (response.data) {
          setContent({
            quote: response.data.quote_text || content.quote,
            author: response.data.quote_author || content.author
          });
        }
      } catch (err) {
        console.log('Using default quote');
      }
    };
    fetchContent();
  }, []);

  return (
    <section className="py-24 bg-[#0f0f12]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-6xl text-amber-500 mb-6">"</div>
        <blockquote className="text-2xl md:text-3xl text-white font-light leading-relaxed mb-8">
          {content.quote}
        </blockquote>
        <cite className="text-amber-500 font-medium not-italic">
          — {content.author}
        </cite>
      </div>
    </section>
  );
};

export default QuoteSection;
